PJQ.views.contacts.EditContactView = PJQ.views.contacts.BaseEditContactView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'edit-company-contact'),
		canEdit: true,
		alert: null
	}
});

PJQ.views.addressbook.EditCompanyView = PJQ.views.contacts.BaseEditContactView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-company'),
		subTemplates: {
			contact: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-company-contact')
		},
		maxWidth: 1400,
		canEdit: true,
		isShowCloseButton: true,
		onDelete: _.noop,
		onCancel: _.noop,
		onSave: _.noop,
		onSaveContact: _.noop,
		isAdmin: true,
		alert: null
	},
	events: {
		"change .contact-edit-phone,.contact-edit-fax,.contact-edit-cell": "formatPhone",
		"keyup .contact-edit-phone-ext": "numbersOnly",
		"keydown .contact-edit-phone-ext": "numbersOnly",
		"click .contact-edit-add": "addNew",
		'click .btn-add-contact': 'addNewContactClicked',
		'click .btn-delete-contact': 'deleteContactClicked',
		'click .btn-copy-contact': 'copyContactClicked',
		'click .btn-set-primary-contact': 'setPrimaryClicked',
		'click .btn-edit-permissions': 'editPermissions',
		'click .btn-copy-phone': 'copyPhone',
		"click .btn-unlock-user": "unlockUser",
		'click .btn-unlink-user': 'unlinkContactUser',
		'click .btn-send-user-reg': 'sendSignUp',
		"click .btn-send-password-reset": "sendPasswordReset",
		"click .btn-company-active": "isActiveClicked",
		"click .btn-contact-active": "checkIsPrimary",
		"click .btn-show-groups": "showRowGroups",
		"click .btn-edit-contact": "contactSwitchedClicked",
		"click .btn-contact-permissions": "editContactPermissions",
		"click .btn-mirror-trades": "mirrorTrades",
		"click .btn-screening-request-company": "newScreeningRequest",
		"click .btn-prequal-audit-log": "viewPrequalAuditLog"
	},
	beforeFirstRender: function () {
		this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
		this.company = this.options.company;

		let fieldUserId = PJQ.app.session.project != null ? PJQ.app.session.project.get('masterUserId') : null,
			fetchERP = (callback) => {
				PJQ.app.session.fetchERPIntegration((erp) => {
					this.erpIntegration = erp;
					if (this.erpIntegration != null) {
						this.company.fetchERPObject(() => {
							callback();
						});
					} else {
						callback();
					}
				});
			},
			fnFetch = () => {
				if (this.company == null) {
					this.company = new PJQ.models.contacts.Company({
						id: this.options.contactCompanyId ? this.options.contactCompanyId : this.options.contactId
					});
				}

				if (!this.company.isNew() && !this.company.isFetched) {
					this.company.fetch({
						success: () => {
							fetchERP(() => {
								this.render();
							});
						}
					});
				} else {
					fetchERP(() => {
						this.render();
					});
				}

				PJQ.app.session.fetchCompanyCustomFields(fieldUserId, _.bind(function (customFields) {
					this.companyCustomFields = customFields;
					if (this.isRendered) {
						this.renderCompanyCustomFields();
					}
				}, this));
				PJQ.app.session.fetchContactCustomFields(fieldUserId, _.bind(function (customFields) {
					this.contactCustomFields = customFields;
					if (this.isRendered) {
						this.renderContactCustomFields();
					}
				}, this));
			};

		this.options.fieldSettingsEnabled = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_CONTACT_FIELD_SETTINGS);
		if (this.options.fieldSettingsEnabled) {
			PJQ.app.session.fetchContactFieldSettings(fieldUserId, _.bind(function (settings) {
				this.coreFieldSettings = settings;
				fnFetch();
			}, this));
		} else {
			fnFetch();
		}
	},
	beforeRender: function () {
		return PJQ.views.contacts.BaseEditContactView.prototype.beforeRender.call(this);
	},
	renderData: function () {
		return {
			company: this.company,
			userTypes: PJQ.app.session.userTypes.getByIsCompany(false),
			prevailingWageLabel: this.options.prevailingWageLabel,
			checkFieldVisible: _.bind(this.checkFieldVisible, this),
			checkFieldRequired: _.bind(this.checkFieldRequired, this),
			enablePermissions: this.options.enablePermissions,
			canEdit: this.options.canEdit,
			canEditCustomFields: this.options.canEditCustomFields,
			isAdmin: this.options.isAdmin,
			showScreenings: this.options.showScreenings,
			showCompanyCustomFields: this.companyCustomFields != null && this.companyCustomFields.length > 0,
			canDelete: PJQ.app.session.hasPermission('contacts.canDelete')
		};
	},
	afterRender: function () {
		if (this.company != null && (this.company.isNew() || this.company.isFetched)) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.company-edit-active'),
				noneSelectedText: 'Select Value',
				defaultValue: this.company.get('isBlacklisted') ? 'inactive' : 'active',
				onChange: _.bind(function (value) {
					this.company.set('isBlacklisted', value === 'inactive');
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.select-approval-level'),
				noneSelectedText: 'Select Value',
				// defaultValue: _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : null,
				onChange: _.bind(function (value) {

				}, this)
			});

			this.renderERP();
			this.renderGrade(this.company);
			this.renderLaborStatus(this.model);
			this.renderSector(this.model);
			this.renderMinority(this.model);

			new PJQ.views.collapse.BaseCollapse({
				el: this.$('#companyInfoCollapseContainer'),
				onShown: _.bind(function (id) {
					switch (id) {
						case 'companyAttachmentsCollapse':
							this.renderCompanyAttachments();
							break;
						case 'prequalCollapse':
							this.renderPrequal();
							break;
						case 'screeningCollapse':
							this.renderScreenings();
							break;
					}
				}, this)
			});

			this.renderCompanyGroups();
			this.setContextContact();
			this.renderContactsTable();
		}
		else {
			new PJQ.Loader(this.$('.modal-body'));
		}

		if (!this.model) {
			this.addNewContact();
		}
	},
	editContactPermissions: function (e) {
		let target = $(e.currentTarget),
			row = this.contactListTable.getRow(target.closest('tr')),
			contact = row.data();
		new PJQ.views.permissions.PermissionsEditorModal({
			model: contact
		});
	},
	viewBidHistory: function () {
		this.bidHistory = new PJQ.views.projects.ProjectParticipantHistoryModal({
			contactId: this.model.get('contactId'),
			onGoToProject: _.bind(function () {
				if (this.options.closeModal) {
					this.options.closeModal();
				}
			}, this)
		});
		this.bidHistory.renderHistory('overall')
	},
	contactSwitched: function (contactId = null) {
		if (this.model && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Save current selected contact?",
				body: "You have made changes to the current selected contact.  Would you like to save this contact before switching contacts?",
				onSave: _.bind(function () {
					this.saveCompanyContact(false, _.bind(function () {
						this.model.set('isNewCopy', false);
						this.setContextContact(contactId);
					}, this));
				}, this),
				onDontSave: _.bind(function () {
					this.model.restore();
					this.setContextContact(contactId);
				}, this)
			})
		}
		else {
			this.setContextContact(contactId);
		}
	},
	setContextContact: function (contactId = null, existingModel) {
		if (this.model != null && this.model.get('contactId') === this.company.get('contactId')) {
			this.model = null;
		}
		let contextId = this.options.contactId;
		if (contactId > 0) {
			contextId = contactId;
		}
		if (contextId > 0 && contextId !== this.company.get('contactId') && this.model.get('contactId') !== contextId) {
			this.model = this.company.contacts.get(contextId);
		}

		if (this.model == null) {
			this.model = this.company.contacts.findWhere({isPrimary: true});
			if (this.model == null && !this.company.isNew()) {
				this.model = this.company.contacts.models[0];
			}
			else if (existingModel) {
				this.model = existingModel;
			}
			else if (this.model == null && this.company.isNew()) {
				let userTypes = PJQ.app.session.userTypes.getByIsCompany(false),
					defaultUserType = _.find(userTypes, function (ut) {
						return ut.get('isDefault');
					});

				if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE))
					defaultUserType = null;
				else if (defaultUserType == null && _.size(userTypes) > 0) {
					defaultUserType = userTypes[0];
				}


				this.model = new PJQ.models.contacts.Contact({
					contactName: "",
					userTypeId: this.company.get('userTypeId') ? this.company.get('userTypeId') : (defaultUserType ? defaultUserType.id : null),
					title: "",
					address1: "",
					address2: "",
					isPrimary: true,
					city: "",
					zip: "",
					state: "",
					country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US',
					phone: "",
					cell: "",
					fax: "",
					email: "",
					notes: "",
					isAutoSelectDisabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DEFAULT_AUTO_SELECT_DISABLED)
				});
				this.company.contacts.add(this.model);
			}
		}

		this.options.contactId = this.model ? this.model.get('contactId') : null;
		let fnRender = _.bind(function () {
			this.renderContact();
			if (this.contactListTable) {
				this.contactListTable.render();
			}
		}, this)
		if (this.model && !this.model.isFetched && this.model.get('contactId') > 0) {
			if (this.model.id != this.model.get('contactId'))
				this.model.id = this.model.get('contactId');

			this.model.fetch({
				success: _.bind(function () {
					fnRender();
				}, this)
			});
		}
		else {
			fnRender();
		}
	},
	renderGrade: function (company) {
		new PJQ.inputs.StarRating({
			el: this.$('.company-rating'),
			rating: company.get('gradeAverage'),
			isReadOnly: true
		});
	},
	renderContact: function () {
		this.renderSubTemplate(false, this.options.subTemplates.contact, this.$('.contact-outer'), this.contactRenderData(), _.bind(function () {
			if (this.model.get('isApprovalRequired') && !PJQ.app.session.hasPermission('contacts.canApprove')) {
				$('.contact-edit-save').hide();
				$('.contact-edit-delete').hide();
			}
			else {
				if (this.model.get('isApprovalRequired')) {
					$('.contact-edit-save-without-approval').removeClass('hidden');
				}
				$('.contact-edit-save').text(this.model.get('isApprovalRequired') ? "Approve" : "Save");
			}

			return PJQ.views.contacts.BaseEditContactView.prototype.renderContact.call(this);
		}, this));
	},
	contactRenderData: function () {
		return {
			company: this.company,
			model: this.model,
			userTypes: PJQ.app.session.userTypes.getByIsCompany(false),
			showNotes: this.options.showNotes !== false,
			checkFieldVisible: _.bind(this.checkFieldVisible, this),
			checkFieldRequired: _.bind(this.checkFieldRequired, this),
			isGroupsRequired: this.options.isGroupsRequired === true,
			canEdit: this.options.canEdit,
			isUserTypeRequired: true,
			canEditCustomFields: this.options.canEditCustomFields,
			showContactCustomFields: this.contactCustomFields != null && this.contactCustomFields.length > 0,
			canDelete: PJQ.app.session.hasPermission('contacts.canDelete')
		};
	},
	groupsChanged: function (data) {
		this.model.groups.reset(data.selected);
		this.renderCompanyGroups();
	},
	renderCompanyGroups: function () {
		this.groupViewer = new PJQ.views.groups.GroupsSelectInput({
			el: this.$('.company-groups'),
			isShowAddButton: false,
			selectedGroups: this.company.getGroups(),
			isReadOnly: true,
			limitGroups: true
		});
	},
	renderCompanyAttachments: function () {
		if (!PJQ.app.session.hasPermission('contacts.canViewAttachments')) {
			return;
		}

		let sortSettings;
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.SORT_COMPANY_ATTACHMENTS))
			sortSettings = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.SORT_COMPANY_ATTACHMENTS);

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.company-documents'),
			collection: this.company.attachments,
			sortBy: sortSettings ? sortSettings.sortBy : null,
			sortDirection: sortSettings ? (sortSettings.sortBy ? 'asc' : 'desc') : null,
			// canUpload: this.model.get('status') !== PJQ.constants.rfi.statuses.CLOSED,
			// canDelete: this.options.canEdit && this.options.isAdmin,
			previewImageDimension: 150,
			canUpload: this.options.canEdit,
			canDownloadAll: true,
			onSuccess: _.bind(function () {
				this.model.isDirty = true;
			}, this),
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	renderContactsTable: function () {
		this.contactListTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".contact-list-table"),
			data: this.company.contacts.models,
			isHideSearch: true,
			paging: false,
			scrollY: "400px",
			scrollCollapse: true,
			rowId: "cid",
			rowCallback: function (row, data) {
				if (data.get('isBlacklisted')) {
					$(row).find('td').css('text-decoration', 'line-through');
				}
			},
			order: [2, 'desc'],
			language: {
				zeroRecords: 'Click "New Contact" to create a new Contact'
			},
			createdRow: _.bind(function (row, data) {
				if (data.get('contactId') === this.options.contactId || data.id === this.options.contactId) {
					if (this.options.contactId == null && data.get('contactName') === '') {
						$(row).addClass('bg-primary-transparent');
					}
					else if (this.options.contactId != null) {
						$(row).addClass('bg-primary-transparent');
					}
				}
			}, this),
			onRowDoubleClick: _.bind(function (row) {
				this.contactSwitched(row.data().get('contactId'));
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: _.bind(function (row) {
							return row.data().get('masterUserId') === 39 || !this.options.canEdit ? 'View' : 'Edit'
						}, this),
						onClick: _.bind(function (row) {
							this.contactSwitched(row.data().get('contactId'));
						}, this)
					},
					{
						name: 'Set as Primary',
						onClick: _.bind(function (row) {
							this.setPrimary(row.data());
						}, this),
						isShown: _.bind(function (row) {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteContact(row)
						}, this),
						isShown: _.bind(function (row) {
							let isDirectoryContact = row.data().get('masterUserId') === 39
							return PJQ.app.session.hasPermission('contacts.canDelete') && !isDirectoryContact;
						}, this)
					}
				]
			},
			columns: [
				{
					"title": "",
					"data": "attributes.isPrimary",
					"render": function (data) {
						return data ? '<i class="fal fa-crown mr-1"></i>' : '';
					}
				},
				{
					"title": "Contact Name",
					"data": "attributes.contactName"
				},
				{
					"data": "attributes.phone",
					"title": "Phone",
					"width": "150px",
					"render": _.bind(function (data, type, row) {
						let html = '<div style="min-width:100px;" class="d-flex align-items-center">',
							phoneFormatted = (row.get('phone') ? PJQ.helpers.formatHelpers.formatPhoneNumber(row.get('phone')) + (_.size(row.get('phoneExtension')) === 0 ? '' : ' x' + row.get('phoneExtension')) : 'N/A');

						if (row.get('phone') !== '')
							html += '<button type="button" class="btn btn-transparent-dark btn-copy-phone" title="Copy Phone #" data-phone="' + phoneFormatted + '"><i class="far fa-phone text-dark"></i></button>';

						html += '<div class="flex-fill ' + (row.get('phone') ? '' : 'text-muted') + '">' + phoneFormatted + '</div>';
						html += '</div>';
						return html;
					}, this)
				},
				{
					"title": "Email",
					"data": "attributes.email"
				},
				{
					"title": "Trades",
					"data": "attributes.groups",
					"width": "200px",
					"render": function (data, type, row) {
						if (_.size(row.groups.models) > 0) {
							let groupNames = [];
							_.each(row.groups.models, function (group) {
								groupNames.push(group.get('groupName'));
							});
							if (_.size(groupNames) > 5) {
								return _.rest(groupNames.reverse(), _.size(groupNames) - 5).reverse().join(', ') + " <br>" +
									"<a href='javascript:void(0)' class='btn-show-groups' title='Click to show complete list of Trades'> " + (_.size(groupNames) - 5) + " more item(s)</a>"
							}
							else {
								return groupNames.join(', ')
							}
						}
						return '';
					}
				},
				{
					"data": "id",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": '200px',
					"render": _.bind(function (data, type, row) {
						let isDirectoryContact = row.get('masterUserId') === 39;
						let html = '<div class="show-on-row-hover text-align-right">';
						if (!isDirectoryContact && this.options.canEdit) {
							if (!row.get('isPrimary')) {
								html += '<button type="button" class="btn btn-success btn-set-primary-contact mr-1" title="Set as Primary Contact"><span class="fal fa-crown"></span></button>';
							}
							if (data != null) {
								html += '<button type="button" class="btn btn-primary btn-copy-contact mr-1" title="Copy Contact"><span class="fal fa-copy"></span></button>';
							}
							if (this.model.get('contactId') !== data) {
								html += '<button type="button" class="btn btn-info btn-edit-contact mr-1" title="Edit Contact"><i class="fal fa-pencil"></i></button>';
							}
							html += '<button type="button" class="btn btn-dark btn-contact-permissions mr-1" title="Permissions"><span class="fal fa-key"></span></button>';
							if (PJQ.app.session.hasPermission('contacts.canDelete')) {
								html += '<button type="button" class="btn btn-danger btn-delete-contact" title="Delete Contact"><i class="fal fa-trash"></i></button>';
							}
						}
						else {
							html += '<button type="button" class="btn btn-info btn-edit-contact" title="View Contact"><i class="fal fa-search"></i></button>';
						}
						html += '</div>';
						return html;
					}, this)
				}
			]
		});
	},
	viewEditHistory: function () {
		this.model.fetchEditHistory(function (editHistory) {
			new PJQ.views.addressbook.EditHistoryModal({
				history: editHistory
			});
		});
	},
	isActiveClicked: function (e) {
		if (!this.options.canEdit) {
			return;
		}

		let button = this.$('.btn-company-active'),
			contactButton = this.$('.btn-contact-active')
		if (!button[0].checked) {
			new PJQ.views.modals.YesNo({
				header: "Set company to inactive?",
				body: "Marking the company as inactive will also make all contacts in this company inactive.  Mark as inactive?",
				onYes: _.bind(function () {
					this.company.set('isBlacklisted', !button[0].checked);
					this.model.set('isBlacklisted', !button[0].checked);
					contactButton[0].checked = false;
				}, this),
				onNo: _.bind(function () {
					button[0].checked = true;
				})
			})
		}
		else {
			this.company.set('isBlacklisted', !button[0].checked);
		}

	},
	checkIsPrimary: function () {
		let button = this.$('.btn-contact-active'),
			companyButton = this.$('.btn-company-active')
		if (!button[0].checked && _.size(_.filter(this.company.contacts.models, _.bind(function (model) {
			return !model.get('isBlacklisted') && model.get('contactId') !== this.model.get('contactId');
		}, this))) >= 1 && this.model.get('isPrimary')) {
			new PJQ.views.addressbook.SelectNewPrimaryContactModal({
				contacts: this.company.contacts,
				currentPrimary: this.model,
				onSave: _.bind(function (model) {
					model.set('isPrimary', true);
					model.save(null, {
						success: _.bind(function () {
							this.model.set('isBlacklisted', true);
							this.model.set('isPrimary', false);
							this.model.save(null, {
								success: _.bind(function () {
									this.model = model;
									this.setContextContact(this.model.get('contactId'));
								}, this)
							});
						}, this)
					})
				}, this),
				onCancel: _.bind(function () {
					button[0].checked = true;
				}, this)
			})
		}
		else if (!button[0].checked && _.size(_.filter(this.company.contacts.models, _.bind(function (model) {
			return !model.get('isBlacklisted') && model.get('contactId') !== this.model.get('contactId');
		}, this))) <= 1 && this.model.get('isPrimary')) {
			new PJQ.views.modals.YesNo({
				header: "Set contact to inactive?",
				body: "This contact is the last remaining active contact in this company.  Marking the contact as inactive will also set the company as inactive.  Would you like to continue?",
				onYes: _.bind(function () {
					this.company.set('isBlacklisted', !button[0].checked);
					this.model.set('isBlacklisted', !button[0].checked);
					companyButton[0].checked = false;
					this.saveCompanyContact();
					this.render();
				}, this),
				onNo: _.bind(function () {
					button[0].checked = true;
				})
			})
		}
	},
	contactSwitchedClicked: function (e) {
		we
		let target = $(e.currentTarget),
			row = this.contactListTable.getRow(target.closest('tr'))
		this.contactSwitched(row.data().get('contactId'));
	},
	showRowGroups: function (e) {
		let target = $(e.currentTarget),
			row = this.contactListTable.getRow(target.closest('tr')),
			data = row.data(),
			groups = [];
		_.each(data.groups.models, function (group) {
			groups.push(group.get('groupName'));
		});
		target[0].outerHTML = ' ' + _.rest(groups, 5).join(', ')
	},
	setPrimaryClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.contactListTable.getRow(target.closest('tr')),
			data = row.data();
		this.setPrimary(data);
	},
	setPrimary: function (data) {
		_.each(this.company.contacts.models, function (contact) {
			contact.set('isPrimary', false);
		});
		if (data == null || this.model.get('contactId') === data.get('contactId')) {
			this.model.set('isPrimary', true);
			this.model.save(null, {
				success: _.bind(function () {
					this.contactListTable.render();
					this.renderContact();
				}, this)
			});
		}
		else {
			this.model.set('isPrimary', false);
			data.set('isPrimary', true);
			data.save(null, {
				success: _.bind(function () {
					this.contactListTable.render();
					this.renderContact();
				}, this)
			});
		}
	},
	addNewContactClicked: function () {
		if (this.model.isNew()) {
			new PJQ.views.modals.YesNo({
				header: "Save Contact?",
				body: "You are already editing a new contact. Would you like to save this contact and start a new one?",
				onYes: _.bind(function () {
					if (this.contactValidation()) {
						this.saveCompanyContact(null, _.bind(function () {
							this.addNewContact();
						}, this));
					}
				}, this)
			})
		}
		else {
			this.addNewContact();
		}
	},
	addNewContact: function () {
		let newContact = new PJQ.models.contacts.Contact({
			contactName: "",
			contactCompanyId: this.company.id ? this.company.id : 0,
			userTypeId: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_PREVENT_DEFAULT_USER_TYPE) ? null : (this.company.get('userTypeId') ? this.company.get('userTypeId') : null),
			title: "",
			address1: "",
			address2: "",
			city: "",
			zip: "",
			state: "",
			country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US',
			phone: "",
			cell: "",
			fax: "",
			email: "",
			notes: ""
		});
		this.company.contacts.add(newContact);
		this.contactListTable.addRow(newContact);
		this.model = newContact;
		this.options.contactId = newContact.get('contactId');
		this.renderContact();
		this.setContextContact(null, newContact);
	},
	copyContactClicked: function () {
		if ((this.model.isNew() || this.model.hasChanged())) {
			if (this.contactValidation()) {
				this.$(".btn-copy-contact").prop('disabled', true);
				this.saveCompanyContact(null, _.bind(function () {
					this.copyContact();
				}, this));
			}
		}
		else {
			this.$(".btn-copy-contact").prop('disabled', true);
			this.copyContact();
		}
	},
	copyContact: function () {

		this.model.copyContact(_.bind(function (model) {
			this.options.contactId = model.contactId;
			this.model = new PJQ.models.contacts.Contact(model);
			this.model.set('isNewCopy', true);
			this.model.id = this.model.get('contactId');
			this.company.contacts.add(this.model);
			this.contactListTable.addRow(this.model);
			this.company.fetch({
				success: _.bind(function () {
					this.renderContact(this.options.contactId);
					this.setContextContact(this.model.get('contactId'));
					this.$(".btn-copy-contact").prop('disabled', false);
				}, this)
			})
		}, this))
	},
	cancel: function () {
		if ((this.model.isDirty || this.company.isDirty || this.model.get('isNewCopy')) && this.options.canEdit && !this.model.get('isApprovalRequired')) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.save();
				}, this),
				onDontSave: _.bind(function () {
					let callback = _.bind(function() {
						this.model.restore();
						if (typeof this.options.onCancel === 'function') {
							this.options.onCancel(this.model);
						}
					}, this);

					if (this.model.get('isNewCopy')) {
						new PJQ.ajax.Request({
							endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
								{
									endpoint: 'contacts',
									value: this.model.get('contactId')
								}
							])
						}).delete().done(_.bind(function (data) {
							callback();
						}, this));
						/*
						this.model.destroy({
							success: _.bind(function() {
								callback();
							}, this)
						});
						 */
					}
					else {
						callback();
					}

				}, this)
			});
		}
		else {
			if (typeof this.options.onCancel === 'function') {
				this.options.onCancel(this.model);
			}
			if (this.options.modal != null) {
				this.options.modal.removeModal();
			}
		}
	},
	delete: function () {

		if (this.model.get("masterUserId") === 39) {
			let match = _.find(this.model.get("contactCustomFieldValues"), function (cf) {
				return (cf.fieldNumber === 3);
			});

			if (match != null && match.value != 8322) {
				new PJQ.views.BaseModal({
					header: "Delete Prohibited",
					body: "Directory Contacts can not be deleted unless their Internal Status is 'New'.  Instead, set them to Inactive, and Approve them to remove them from the Approval Queue."
				});
				return;
			}
		}

		let message = "Are you sure you want to delete this company?";
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: message,
			onDelete: _.bind(function () {
				this.company.destroy();
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete(this.company);
				}
			}, this)
		});
	},
	deleteContactClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.contactListTable.getRow(target.closest('tr'));
		this.deleteContact(row);
	},
	deleteContact: function (row) {
		let contact = row.data();
		let message = "Are you sure you want to delete this contact?";
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: message,
			onDelete: _.bind(function () {
				this.company.contacts.remove(contact);
				contact.destroy();
				this.contactListTable.removeRow(row);
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete(this.model);
				}
			}, this)
		});
	},
	copyPhone: function (e) {
		let inputId = 'h_input_' + _.uniqueId(),
			hiddenInput = $('<input>', {
				value: $(e.currentTarget).data('phone'),
				style: 'position: absolute;left:-2000px;top:-2000px',
				id: inputId
			});
		this.$el.append(hiddenInput);
		hiddenInput[0].select();
		document.execCommand("copy");
		hiddenInput.remove();
		PJQ.notifications.notify.successNotify({
			message: 'Number copied to clipboard.'
		});
	},
	save: function () {
		this.company.set({
			notes: this.$('.company-edit-notes').val(),
			companyName: this.$('.company-edit-name').val()
		});
		if (this.companyValidation() && this.contactValidation()) {
			this.saveCompanyContact(false, _.bind(function (success) {
				if (success) {
					this.options.onSave(this.model);
				}
			}, this));
		}
	},
	saveWithoutApproval: function () {
		this.company.set({
			notes: this.$('.company-edit-notes').val(),
			companyName: this.$('.company-edit-name').val()
		});
		if (this.companyValidation() && this.contactValidation()) {
			this.saveCompanyContact(false, _.bind(function (success) {
				if (success) {
					this.options.onSave(this.model);
				}
			}, this), false);
		}
	},
	companyValidation: function () {
		let $company = this.$('.company-edit-name'),
			scrollTopError = $('.validation-error').offset().top,
			hasCompanyError = false,
			companyNameValue = this.$('.company-edit-name').val();

		PJQ.helpers.inputHelpers.setInputError($company, true);
		if (_.size(companyNameValue) === 0) {
			PJQ.helpers.inputHelpers.setInputError($company, false);
			hasCompanyError = true;
		}
		if (this.options.canEditCustomFields) {
			if (this.companyCustomFieldsForm) {
				if (!this.companyCustomFieldsForm.validate()) {
					let $cac = this.$('#contactEditCompanyCustomFieldsCollapse');
					if (!$cac.hasClass('show'))
						$cac.siblings('.card-header').click();
					hasCompanyError = true;
				}
			}
		}
		if (hasCompanyError) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Required fields are empty or have an incorrect value'
			});

			$('div.modal').animate({
				scrollTop: scrollTopError
			}, 500);
			return false
		}
		else {
			this.$('.validation-error').empty();
			return true
		}
	},
	saveCompany: function (callback = _.noop) {
		if (this.company.id === this.model.get('contactId')) {
			callback(true);
			return;
		}

		let $companyName = this.$('.company-edit-name'),
			$notes = this.$('.company-edit-notes');
		this.company.set({
			companyName: _.size($companyName) > 0 ? $companyName.val() : this.company.get('companyName'),
			notes: _.size($notes) > 0 ? $notes.val() : this.company.get('notes')
		});
		if (this.company.hasChanged()) {
			this.company.save({
				companyName: _.size($companyName) > 0 ? $companyName.val() : this.company.get('companyName'),
				notes: _.size($notes) > 0 ? $notes.val() : this.company.get('notes')
			}, {
				success: _.bind(function (model) {
					callback(true);
				}, this),
				error: _.bind(function (model, response) {
					callback(true);
				}, this)
			});
		}
	},
	contactValidation: function () {
		let hasError = false,
			$scrollTo = null;
		//only validate core contact information if they can actually edit it
		//they may only be able to edit the custom fields
		if (this.options.canEdit) {
			let validate = this.validateCoreFields();
			if (!validate.valid) {
				hasError = true;
				$scrollTo = validate.$scrollTo;
			}

			if (this.model instanceof PJQ.models.users.User && this.model.isNew()) {
				let $username = this.$('.input-username');
				PJQ.helpers.inputHelpers.setInputError($username, true);
				if (_.size(this.model.get('username')) === 0) {
					PJQ.helpers.inputHelpers.setInputError($username, false);
					hasError = true;
					if ($scrollTo == null) {
						$scrollTo = $username;
					}
				}

				let $password = this.$('.input-password');
				PJQ.helpers.inputHelpers.setInputError($password, true);
				if (_.size(this.model.get('password')) === 0) {
					PJQ.helpers.inputHelpers.setInputError($password, false);
					hasError = true;
					if ($scrollTo == null) {
						$scrollTo = $password;
					}
				}
			}
		}

		if (this.options.canEditCustomFields) {
			if (this.contactCustomFieldsForm) {
				if (!this.contactCustomFieldsForm.validate()) {
					let $cac = this.$('#contactEditContactCustomFieldsCollapse');
					if (!$cac.hasClass('show'))
						$cac.siblings('.card-header').click();
					hasError = true;
					if ($scrollTo == null) {
						$scrollTo = this.contactCustomFieldsForm.$el;
					}
				}
			}
		}

		if (hasError) {
			new PJQ.Alert(this.$('.validation-error-contact'), {
				type: 'danger',
				text: 'Required fields are empty or have an incorrect value'
			});

			if (_.size($scrollTo) > 0) {
				$('div.modal').animate({
					scrollTop: $scrollTo.offset().top
				}, 500);
			}
		}
		else {
			this.$('.validation-error-contact').empty();
		}
		return !hasError;
	},
	mirrorTrades: function () {
		new PJQ.views.modals.YesNo({
			header: "Mirror Confirmation",
			body: "Are you sure you want to mirror Trades from this contact to all contacts in this company?",
			onYes: _.bind(function () {
				new PJQ.ajax.Request({
					endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
						{
							endpoint: 'contacts',
							value: this.model.get('contactId')
						},
						{
							endpoint: 'mirrortrades'
						},
					])
				}).post().done(_.bind(function () {
					PJQ.notifications.notify.successNotify({
						message: 'Trades successfully mirrored'
					});
					this.company.fetch({
						success: _.bind(function () {
							this.render();
							this.renderContactsTable()
						}, this)
					})
				}, this)).fail(function (xhr, err, result) {
					PJQ.notifications.notify.errorNotify({
						message: 'Something went wrong!'
					});
				});
			}, this)
		})
	},
	saveCompanyContact: function (isAddToProject, callback = _.noop, isApprove = true) {
		if (!(this.model instanceof PJQ.models.users.User || this.model.get('contactId') < 0)) {
			if (this.groupSelector != null) {
				this.model.groups.reset(this.groupSelector.getGroupsData().all);
			}
		}

		let loader = new PJQ.Loader(this.$('.modal-content')),
			isNew = this.model.isNew();
		if (this.model.get('isApprovalRequired') && isApprove) {
			this.model.approve(_.bind(function () {
				PJQ.notifications.notify.successNotify({
					message: 'Successfully approved contact'
				});
				loader.remove();
				callback(true);
			}, this))
		}
		else {
			this.model.set('companyCustomFieldValues', this.companyCustomFieldsForm != null ? this.companyCustomFieldsForm.getChanged() : null);
			this.model.set('contactCustomFieldValues', this.contactCustomFieldsForm != null ? this.contactCustomFieldsForm.getChanged() : null);
			let isContactNew = this.model.isNew();
			this.model.save(null, {
				notify: false,
				success: _.bind(function (model) {
					let fnContinue = _.bind(function() {
						let ccId = model.get('contactCompanyId');
						this.company.set({
							id: ccId,
							contactId: ccId
						});
						_.each(this.company.models, function (mod) {
							mod.set('contactCompanyId', ccId);
						});
						this.saveCompany(_.bind(function () {
							let message = isAddToProject ? 'Successfully added bid participant' : 'Successfully saved contact';
							if (this.options.isSelfEdit) {
								message = 'Successfully saved your info'
							}
							else {
								if (this.model instanceof PJQ.models.users.User) {
									if (isNew) {
										PJQ.app.session.users.add(this.model);
										message = 'Successfully added user';
									}
									else {
										message = 'Successfully saved user';
									}
								}
							}
							PJQ.notifications.notify.successNotify({
								message: message
							});
							loader.remove();

							callback(true);
						}, this));
					}, this);

					if (typeof this.options.onSaveContact === 'function') {
						if (isContactNew && _.size(this.model.get('groups'))>0) {
							new PJQ.ajax.Request({
								endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
									{
										endpoint: 'contacts'
									},
									{
										endpoint: 'contactgroupids'
									}
								], [
									{
										parameter: 'contactIds',
										value: this.model.get('contactId')
									}
								])
							}).get().done(_.bind(function (response) {
								this.model.set('contactGroups', response.contactGroupIds);
								this.options.onSaveContact(this.model, isContactNew);
								fnContinue();
							}, this));
						} else {
							this.options.onSaveContact(this.model, isContactNew);
							fnContinue();
						}
					}

				}, this),
				error: _.bind(function (model, response) {
					if (response.responseJSON && response.responseJSON.message && response.responseJSON.message === 'EmailExists') {
						new PJQ.views.BaseModal({
							header: "Email Exists",
							body: "Another contact in your Address Book has this email address already.   Do you still want to save this record?",
							okButtonText: 'Yes',
							secondaryButtonText: 'Go to Contact',
							isShowCancelButton: true,
							isShowSecondaryButton: true,
							onOk: _.bind(function () {
								loader.remove();
								this.model.set('isForceSaveExistingEmail', true);
								this.saveCompanyContact(isAddToProject, callback);
							}, this),
							onSecondary: _.bind(function () {
								new PJQ.ajax.Request({
									endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
										{
											endpoint: 'contacts'
										},
										{
											endpoint: 'email'
										}
									], [
										{
											parameter: 'email',
											value: this.model.get('email')
										}
									])
								}).get().done(_.bind(function (data) {
									this.company = new PJQ.models.contacts.Company(data);
									let contact = _.find(data.contacts, function (contact) {
										return contact.email === this.model.get('email');
									}, this)
									this.options.contactId = contact.contactId;
									this.render();
								}, this)).fail(function (xhr, err, result) {
									PJQ.notifications.notify.errorNotify({
										message: 'Something went wrong!'
									});
								});
							}, this)
						});
					}
					else {
						PJQ.notifications.notify.errorNotify({
							message: 'Failed to save'
						});
						callback(false);
					}
				}, this)
			});
		}
	},
	viewPrequalAuditLog: function(e) {
		e.stopPropagation();
		new PJQ.views.prequal.PrequalAuditLogModal({
			contactId: this.model.get('contactId')
		});
	}
});

PJQ.views.addressbook.EditCompanyModal = PJQ.views.contacts.BaseEditContactModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'Modal-Edit-Company'),
		canEdit: true,
		minWidth: 600,
		maxWidth: 1200,
		alert: null,
		onDelete: _.noop,
		onCancel: _.noop,
		onSave: _.noop,
		onSaveContact: _.noop,
		isShowCloseButton: true
	},
	events: {
		'click .btn-bid-history': 'viewBidHistory',
		'click .btn-edit-history': 'viewEditHistory',
		"click .contact-edit-cancel": "cancel",
		"click .contact-edit-save": "save",
		"click .contact-edit-save-without-approval": "saveWithoutApproval",
		"click .contact-edit-delete": "delete"
	},
	beforeModalCreated: function () {
		this.company = this.options.company;

		if (this.company == null) {
			this.company = new PJQ.models.contacts.Company({
				id: this.options.contactCompanyId ? this.options.contactCompanyId : this.options.contactId
			});
		}

		if (!this.company.isNew() && !this.company.isFetched) {
			this.company.fetch({
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}
		else {
			this.render();
		}
	},
	getContactElement: function(){
		return this.$('.contact-edit');
	},
	shouldRenderInnerView: function () {
		return this.company != null && (this.company.isNew() || this.company.isFetched);
	},
	renderData: function () {
		return {
			company: this.company,
			canEditCustomFields: this.options.canEditCustomFields,
			canEdit: this.options.canEdit,
			isAdmin: this.options.isAdmin,
			canDelete: PJQ.app.session.hasPermission('contacts.canDelete')
		};
	},
	getInnerViewType: function () {
		return PJQ.views.addressbook.EditCompanyView;
	},
	getInnerViewOptions: function () {
		return {
			company: this.company,
			model: this.options.model,
			contactId: this.options.contactId,
			contactCompanyId: this.options.contactCompanyId,
			onCompanySave: this.options.onSave,
			onDelete: this.options.onDelete,
			onSaveContact: this.options.onSaveContact,
			closeModal: _.bind(function () {
				this.removeModal();
			}, this)
		};
	},
	saveWithoutApproval: function () {
		this.editView.saveWithoutApproval();
	},
	viewEditHistory: function () {
		this.editView.viewEditHistory();
	},
	viewBidHistory: function () {
		this.editView.viewBidHistory();
	}
});

PJQ.views.addressbook.ApproveAddressBookContactModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'modal-contact-approval'),
		minWidth: 600,
		maxWidth: "60%",
		isShowCloseButton: true,
		onSave: _.noop
	},
	events: {
		'click .approval-save': 'approveClicked',
		'click .input-approve-status': 'approvalStatusChanged',
		'change .input-approve-all': 'approveAll'
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (!PJQ.app.session.hasPermission('contacts.canApprove')) {
			this.$('.approval-save').hide();
		}
		new PJQ.inputs.Selectpicker({
			el: this.$('.select-merge-company'),
			noneSelectedText: 'Select Merge Company',
			hideDisabled: false,
			onChange: _.bind(function (value) {
				this.model.set('contactCompanyId', value);
			}, this)
		});
		this.renderDataTable();
	},
	renderDataTable: function () {
		let hasUnapproved = null != _.find(this.model.approvalUpdates.models, function (update) {
			return !update.get('isApproved');
		});
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".approval-updates-table"),
			data: this.model.approvalUpdates.models,
			rowId: "cid",
			paging: false,
			isHideSearch: true,
			order: [0, 'asc'],
			language: {
				zeroRecords: 'No Approvals Pending'
			},
			columns: [
				{
					"title": "Field",
					"data": "attributes.fieldLabel"
				},
				{
					"title": "Old Value",
					"data": "attributes.oldValueDisplay"
				},
				{
					"title": "New Value",
					"data": "attributes.newValueDisplay"
				},
				{
					"title": '<div class="pretty p-switch p-fill p-toggle mt-2"><input type="checkbox" class="input-approve-all" ' + (hasUnapproved ? '' : 'checked') + '><div class="state p-success"><label>&nbsp;</label></div></div>',
					"data": "attributes.isApproved",
					"orderable": false,
					"render": _.bind(function (data, type, row) {
						return "<div class=\"form-group\">\n" +
							"        <div>\n" +
							"            <div class=\"pretty p-switch p-fill p-toggle mt-3\">\n" +
							"                  <input type=\"checkbox\" class=\"input-approve-status\" data-cid='" + row.cid + "' " + (row.get('isApproved') ? "checked" : "") + "/>\n" +
							"                <div class=\"state p-success\">\n" +
							// " &#8205; " is an invisible character. If there is no label the switch's positioning messes up.
							"                    <label><span class=\"fs-16\">&#8205;</span></label>\n" +
							"                </div>\n" +
							"            </div>\n" +
							"        </div>\n" +
							"    </div>"
					}, this)
				}
			]
		});
	},
	approvalStatusChanged: function (e) {
		let cid = e.target.dataset.cid,
			value = e.target.checked,
			model = this.model.approvalUpdates.get(cid);
		model.set('isApproved', value);
		this.updateApproveAllInput();
	},
	approveClicked: function () {
		let loader = new PJQ.Loader(this.$('.modal-content'));
		this.approve(_.bind(function (success) {
			if (success) {
				loader.remove();
				this.removeModal();
				PJQ.notifications.notify.successNotify({
					message: 'Successfully approved contact'
				});
				this.options.onSave(this.model);
			}
		}, this));
	},
	approve: function (callback = _.noop) {
		this.model.approve(_.bind(function () {
			if (this.options.onApprove) {
				this.options.onApprove(this.model);
			}
			callback(true);
		}, this));
	},
	approveAll: function (e) {
		let isApproved = $(e.currentTarget).prop('checked');
		_.each(this.model.approvalUpdates.models, function (update) {
			update.set('isApproved', isApproved);
		});
		this.renderDataTable();
	},
	updateApproveAllInput: function () {
		let hasUnapproved = null != _.find(this.model.approvalUpdates.models, function (update) {
			return !update.get('isApproved');
		});
		this.$('.input-approve-all').prop('checked', !hasUnapproved);
	},
});

PJQ.views.addressbook.EditHistoryModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-history-modal'),
		subTemplates: {
			history: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'edit-history'),
		},
		width: '50%',
		maxWidth: 700,
		onSave: _.noop
	},
	events: {},
	afterRender: function () {
		this.renderHistory()
	},
	renderHistory: function () {
		this.renderSubTemplate(false, this.options.subTemplates.history, this.$('.history-outer'), {
			history: this.options.history.models
		});
	}
});

PJQ.views.addressbook.SelectNewPrimaryContactModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'select-primary-contact-modal'),
		subTemplates: {
			contacts: new PJQ.templating.Template(PJQ.constants.modules.ADDRESSBOOK, 'primary-contact'),
		},
		width: '50%',
		maxWidth: 500,
		onSave: _.noop
	},
	events: {
		"click .primary-contact-card": "contactClicked",
		"click .btn-save": "savePrimary",
		"click .btn-cancel": "cancel"
	},
	afterRender: function () {
		this.renderContacts();
	},
	renderContacts: function () {
		this.renderSubTemplate(false, this.options.subTemplates.contacts, this.$('.contacts-outer'), {
			contacts: this.options.contacts.models,
			currentPrimary: this.options.currentPrimary
		});
	},
	contactClicked: function (e) {
		let target = $(e.currentTarget),
			cid = target.data('cid');
		this.newPrimary = this.options.contacts.get(cid);
		$('.primary-contact-card').removeClass('selected');
		target.addClass('selected');

		if (this.newPrimary) {
			this.$('.btn-save').attr('disabled', false);
		}
	},
	cancel: function () {
		if (this.options.onCancel) {
			this.options.onCancel();
		}
		this.removeModal();
	},
	savePrimary: function () {
		if (this.options.onSave) {
			this.options.onSave(this.newPrimary);
			this.removeModal();
		}
	}
});
